import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/bgab.png'


const _withScopeId = n => (_pushScopeId("data-v-7b4e364f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "value" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "heading-2" }, "The values we live by", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center value-p" }, " Everything we do is motivated by our values, which inform every aspect of our business. ", -1))
const _hoisted_4 = { class: "value-body" }
const _hoisted_5 = {
  class: "value-box d-flex flex-column flex-md-row",
  style: {"margin-bottom":"6.8rem"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "w-100"
  })
], -1))
const _hoisted_7 = { class: "value-box d-flex flex-column flex-md-row" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "w-100"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list1, (list, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "value-item",
            key: i
          }, [
            _hoisted_6,
            _createElementVNode("h3", null, _toDisplayString(list.heading), 1),
            _createElementVNode("p", null, _toDisplayString(list.text), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list2, (list, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "value-item",
            key: i
          }, [
            _hoisted_8,
            _createElementVNode("h3", null, _toDisplayString(list.heading), 1),
            _createElementVNode("p", null, _toDisplayString(list.text), 1)
          ]))
        }), 128))
      ])
    ])
  ]))
}